export const API_RESPONSE_ERROR = {
  NETWORK_ERROR: 'Network Error',
};
